import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { qualifiedSharedDividendsReportSnoozed } from "store/actions/qualifiedSharedDividendsActions";
//#endregion
//#region types
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { QualifiedShareDividendMoreActionProps } from "models/propTypes/qualifiedShareDividendsPropTypes";
//#endregion
//#region components
import { MoreActions, useSnoozeAction } from "components/common";
import { useQualifiedShareDividendsService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const QualifiedShareDividendMoreActions: React.FC<QualifiedShareDividendMoreActionProps> = (props) => {
  const qualifiedShareDividendsService = useQualifiedShareDividendsService();
  const { qualifiedShareDividend, markAsDoneHandler, disableSuccessMessages } = props;
  const dispatch = useDispatch();

  //#region snooze
  const onSnoozeSuccess = () => {
    markAsDoneHandler && markAsDoneHandler();
    qualifiedShareDividend.id && dispatch(qualifiedSharedDividendsReportSnoozed(qualifiedShareDividend.id));
  };

  const { snoozeAction } = useSnoozeAction(
    qualifiedShareDividend.id ?? 0,
    WintSuperkollAPIModel.TodoType.QualifiedShareDividend,
    onSnoozeSuccess
  );
  //#endregion

  //#region download
  const onDownloadClick = async () => {
    return qualifiedShareDividendsService.downloadPdf(qualifiedShareDividend.id ?? "");
  };

  const downloadAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Download),
    icon: IconDefinitionConstants.WDownload,
    onClickHandler: onDownloadClick,
  };

  //#endregion

  return <MoreActions menuItems={[snoozeAction, downloadAction]} disableSuccessMessages={disableSuccessMessages} />;
};

export default QualifiedShareDividendMoreActions;
